import { useMutation } from 'react-query';
import { nextClient, LoggerInstance, INextError, CustomOptions } from '@vfit/shared/data-access';
import {
  GetCustomerResponse,
  IFindCallerResponse,
  IShoppingCartResponse,
} from '@vfit/consumer/data-access';
import { API, getFromLocalStorageByKey } from '@vfit/shared/data-access';
import {
  IUseReserveUnreserveVoucherMutation,
  IUseReserveUnreserveVoucherPayload,
  IUseReserveUnreserveVoucherResponse,
} from './reserveUnreserveVoucher.models';

export const reserveUnreserveVoucherService = (
  cartId: string,
  payload: IUseReserveUnreserveVoucherPayload,
  customOptions?: CustomOptions
): Promise<IUseReserveUnreserveVoucherResponse> =>
  nextClient.post(`${API.ORDER}/${cartId}/${API.UPDATE_VOUCHER}`, payload, {
    ...(customOptions?.headers && { headers: customOptions.headers }),
    ...(customOptions?.silentLoginHeaders && {
      silentLoginHeaders: customOptions.silentLoginHeaders,
    }),
  });

export const useReserveUnreserveVoucher = () =>
  useMutation(
    ['reserveUnreserveVoucher'],
    ({ voucherId, status, boArray }: IUseReserveUnreserveVoucherMutation) => {
      const shoppingCart: IShoppingCartResponse = getFromLocalStorageByKey('shoppingCart');
      const customerData: GetCustomerResponse[] = getFromLocalStorageByKey('customerData');
      const findCaller: IFindCallerResponse = getFromLocalStorageByKey('findCaller');
      const cartId = shoppingCart?.id;
      const customerId = customerData?.[0]?.id || findCaller?.customerRef?.id;
      const payload: IUseReserveUnreserveVoucherPayload = {
        voucherId,
        customerId,
        status,
        boArray,
      };
      return reserveUnreserveVoucherService(cartId as string, payload);
    },
    {
      onSuccess: (data: IUseReserveUnreserveVoucherResponse) => {
        LoggerInstance.log('Reserve unreserve', data);
      },
      onError: (error: INextError) => {
        LoggerInstance.error(`ERROR - reserveUnreserveVoucher: `, error);
      },
    }
  );
